import {
  takeLatest,
  put,
  call,
  select,
  cancel,
  delay,
} from 'redux-saga/effects';

import { redirectToUsers } from '../../../utils/appointments/redirect-utils';
import * as inlineVisitTimeSlots from '../requests/inline-visits-time-slots';
import {
  selectInlineVisitTimeSlots,
  selectInlineVisitTimeSlotsPending,
} from '../selectors';

function* handleGetAvailableTimeSlots() {
  const timeSlots = yield select(selectInlineVisitTimeSlots);
  const loading = yield select(selectInlineVisitTimeSlotsPending);
  const availableTimeSlots = !loading && timeSlots;

  if (availableTimeSlots && timeSlots.length > 0) {
    yield cancel();
  }

  if (availableTimeSlots && timeSlots.length === 0) {
    yield put(
      inlineVisitTimeSlots.actions.showErrorAlert(
        'appointment.inlineVisit.error.noAvailableTime',
      ),
    );
    yield delay(4000);
    yield call(redirectToUsers);
  }
}

export default function* getAvailableTimeSlots() {
  yield takeLatest(
    inlineVisitTimeSlots.consts.SUCCEED,
    handleGetAvailableTimeSlots,
  );
}



// WEBPACK FOOTER //
// ./src/redux/appointmentForm/sagas/inline-visits-time-slots-saga.js